/**
 * Export tracked properties to a CSV download.
 * Same columns/format as the original PropertiesContainer implementation.
 *
 * @param {Array} properties - property documents (sold or unsold)
 * @param {string} [suffix=''] - optional filename suffix (e.g. "-sale")
 * @returns {boolean} true when a download was triggered
 */
export const exportPropertiesToCSV = (properties, suffix = '') => {
  if (!properties || properties.length === 0) return false;

  const headers = ['Title', 'Price', 'Start Price', 'Area', 'Bedrooms', 'Bathrooms', 'Property Type', 'Published Date', 'URL', 'Notes'];
  const rows = properties.map((property) => {
    let propertyType = '';
    if (property.forSale && property.forRent) propertyType = 'Sale & Rent';
    else if (property.forSale) propertyType = 'For Sale';
    else if (property.forRent) propertyType = 'For Rent';

    return [
      `"${property.title || ''}"`,
      property.lastKnownPrice || '',
      property.startPrice || '',
      property.area || '',
      property.bedrooms || '',
      property.bathrooms || '',
      `"${propertyType}"`,
      property.publishedDate || '',
      `"${property.url || ''}"`,
      `"${property.notes || ''}"`,
    ].join(',');
  });

  const csvContent = [headers.join(','), ...rows].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `properties${suffix}-${new Date().toISOString().split('T')[0]}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
  return true;
};

/** Relative "x ago" label for dates/timestamps; returns '' for invalid input. */
export const timeAgo = (input) => {
  if (!input) return '';
  const date = typeof input.toDate === 'function' ? input.toDate() : input instanceof Date ? input : new Date(input);
  if (isNaN(date.getTime())) return '';
  const diff = Date.now() - date.getTime();
  const m = Math.round(diff / 60000);
  if (m < 1) return 'just now';
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.round(h / 24);
  if (d < 30) return `${d}d ago`;
  const mo = Math.round(d / 30);
  if (mo < 12) return `${mo}mo ago`;
  return `${Math.round(mo / 12)}y ago`;
};
